/** How To fetch
 *  const q = queryParser('?a=123')
 * q.get('a') // result = 123
 */
export const decodeQueryUrl = (url) => {
  const isUrl = !!url
  if (isUrl) {
    let str = decodeURIComponent(url)
    str = str.replace('?', '')
    let chunks = str.split('&')
    let obj = {}
    for (let c = 0; c < chunks.length; c += 1) {
      let split = chunks[c].split('=', 2)
      obj[split[0]] = split[1]
    }
    return obj
  }
  return {}
}

export const encodeQueryUrl = (data) => {
  return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&')
}



// WEBPACK FOOTER //
// ./src/utils/queryParser.js